import { Directive, HostListener } from "@angular/core";

@Directive({
  selector: "[appSkipLink]",
})
export class SkipLinkDirective {

  constructor() {
  }

  @HostListener("click", ["$event"])
  onClick(event: Event) {
    // Prevent the browser's default jump so we control focus & scroll precisely.
    event.preventDefault();

    const mainContent = document.getElementById("main-content");
    if (mainContent) {
      // Ensure the main content is brought into view, then focus it.
      mainContent.scrollIntoView({ behavior: "instant", block: "start" } as ScrollIntoViewOptions);
      mainContent.focus();
    }
  }
}
